import {Controller} from 'react-hook-form'
import Checkbox from '../Checkbox'

const FormCheckbox = ({name, label, control, ...p}) => {
    label = label || name
    return (
        <Controller
            name={name}
            control={control}
            render={({field: {onChange, value}}) => (
                <Checkbox
                    onChange={onChange}
                    value={value}
                    label={label}
                    {...p}
                />
            )}
        />
    )
}

export default FormCheckbox
